import { AgmMap, LatLngLiteral, MapsAPILoader } from "@agm/core";
import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    NgZone,
    OnInit,
    Output,
    EventEmitter,
    ViewChild,
    Input,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import * as e from "express";
import { Subscription } from "rxjs";
import { AccountSettingService } from "src/app/Services/account-setting.service";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { HomePageService } from "src/app/Services/home-page.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import Swal from "sweetalert2";
@Component({
    selector: "app-multi-invintory-area",
    templateUrl: "./multi-invintory-area.component.html",
    styleUrls: ["./multi-invintory-area.component.scss"],
})
export class MultiInvintoryAreaComponent implements OnInit {
    @Output() backToBothFunc: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeFunc: EventEmitter<any> = new EventEmitter<any>();
    @Output() addressemit: EventEmitter<any> = new EventEmitter<any>();
    @Input("addressForm") addressForm: boolean = false;
    @Input("address_coordnates") address_coordnates: any;
    areaForm: FormGroup = new FormGroup({});
    loadingSpinner: boolean = false;
    loadingSpinnerDrag: boolean = false;
    cities: any = [];
    user: any = JSON.parse(localStorage.getItem("auth_user_crocs") || "{}");
    areaList: any = [];
    lang: any;
    address: any = {};
    loading = true;
    loadingCities = true;
    // lat: any;
    // lng: any;
    public lat: any;
    public lng: any;
    public cordnates: any = {
        lat: 0,
        lng: 0,
        lat_marker: 0,
        lng_marker: 0,
    };
    zoom: number = 16;
    public areaData: any = "";
    public coordnatesPaths = [];
    public areaDataMessage!: string;
    public mapObj: any;
    multiInvMap: any;
    allowGeoRecall = true;
    countLocationAttempts = 0;
    mapLoading = true;
    isPleaseZoom: boolean = true;
    zoom_level: number = 14;
    areaDataMessageZoom!: string;
    productList: any =
        JSON.parse(<string>localStorage.getItem("cartItems")) || [];
    environmentVariables: any;
    @ViewChild(AgmMap) agmMAp: any;
    initSubscription: Subscription;
    constructor(
        public embryoService: EmbryoService,
        private formBuilder: FormBuilder,
        private translate: TranslateService,
        private auth: LoginUsersService,
        private homePageService: HomePageService,
        private accountSettingService: AccountSettingService,
        private confgServ: StaticPagesService,
        private cdRef: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router

    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });
        this.getInitilizingData();
        this.initSubscription = this.homePageService
            .getInitData()
            .subscribe((response) => {
                if (response) {
                    if (this.environmentVariables) {
                        if (this.environmentVariables.ENABLE_MULTI_INVENTORY) {
                            if (
                                this.environmentVariables
                                    .ENABLE_PROFILE_SET_AREA_FROM_MAP 
                                    // ||
                                    // this.environmentVariables.ADD_ADDRESS_CONFIG === 'map' ||
                                    // this.environmentVariables.ADD_ADDRESS_CONFIG === 'map_address' 
                            ) {
                                this.getPolygons(response.profile);
                            } else {
                                this.getCities(response);
                            }
                        }
                    }
                }
            });
    }

    //================================================================
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }
    //================================================================
    getCities(res: any) {
        if (res && res.profile && res.profile.token) {
            this.getAvalibleAreas();
        }
    }
    //================================================================
    getAvalibleAreas() {
        this.loadingCities = true;
        this.loading = true;
        this.accountSettingService.getAvailableCities().subscribe({
            next: (response: any) => {
                this.loading = false;
                if (response.code === 200) {
                    this.cities = response.data;
                    if (this.user && this.user.area && this.user.area.city_id) {
                        this.getArea(this.user.area.city_id);
                    }
                }
                this.loadingCities = false;
            },
        });
    }
    ngOnChanges() {
        if (this.address_coordnates) {
            setTimeout(() => {
                this.cordnates.lat = parseFloat(this.address_coordnates.lat);
                this.cordnates.lng = parseFloat(this.address_coordnates.lng);
                this.cordnates.lat_marker = parseFloat(
                    this.address_coordnates.lat
                );
                this.cordnates.lng_marker = parseFloat(
                    this.address_coordnates.lng
                );
                this.checkArea(this.cordnates, 16 , 'ngOnChanges');
            }, 200);
        }
        if (
            this.addressForm &&
            !this.environmentVariables?.ENABLE_MULTI_INVENTORY
        ) {
            this.mapLoading = false;
        }
    }
    ngOnDestroy() {
        this.initSubscription.unsubscribe();
    }
    //================================================================
    public getArea(area: any) {
        const index = this.cities.findIndex((item: any) => item.id == area);
        if (index !== -1) {
            if (this.cities[index].areas.length) {
                this.areaList = this.cities[index].areas;
            } else {
                this.areaList = [];
            }
        }
    }
    //================================================================
    ngOnInit(): void {
        this.embryoService.productCartSub.subscribe((res) => {
            if (res?.items) {
                this.productList = res?.items;
            } else {
                this.productList = res;
            }
        });
        this.auth.getUserDataEmit().subscribe((user) => {
            this.user = user;
            if (this.user.lat && this.user.lng) this.cordnates.lat = user.lat;
            this.cordnates.lng = user.lng;
            this.cordnates.lat_marker = user.lat;
            this.cordnates.lng_marker = user.lng;
            this.setForm();
        });
        this.setForm();
    }
    //================================================================
    setForm() {
        if (this.user && this.user?.area) {
            this.getArea(this.user?.area?.city_id);
        }
        this.areaForm = this.formBuilder.group({
            city_id: [
                this.user ? this.user?.area?.city_id : "",
                Validators.required,
            ],
            area_id: [
                this.user ? this.user?.area?.id : "",
                Validators.required,
            ],
        });
    }
    //================================================================
   getPolygons(res: any) {
        this.getLocation();
        if (res && res.token) {
            this.getAllAreas();
            if (this.user && this.user.lat && this.user.lng) {
                this.cordnates.lat = this.user.lat;
                this.cordnates.lng = this.user.lng;
                this.cordnates.lat_marker = this.user.lat;
                this.cordnates.lng_marker = this.user.lng;
                this.checkArea(this.cordnates, 16 , 'this.user');
            } else {
                this.cordnates.lat = +this.environmentVariables.GOOGLE_MAP_LATITUDE;
                this.cordnates.lng = +this.environmentVariables.GOOGLE_MAP_LONGITUDE;
                this.cordnates.lat_marker =
                    +this.environmentVariables.GOOGLE_MAP_LATITUDE;
                this.cordnates.lng_marker =
                    +this.environmentVariables.GOOGLE_MAP_LONGITUDE;
                this.checkArea(this.cordnates, 9 , 'config');
                  this.mapLoading = false;
                  this.isPleaseZoom = true;
                // this.getLocation();
            }
        }
    }
    //================================================================
    reInitialize() {
        // var initalizePrams: any = {};
        var initalizePrams: any = {};
        initalizePrams["query_params"] = { ...this.route.snapshot.queryParams };
        this.homePageService
            .getInitializationsData(initalizePrams)
            .subscribe((res: any) => {
                if (res && res.data) {
                    this.homePageService.setInitData(res.data);
                    localStorage.setItem(
                        "compareItems",
                        JSON.stringify(res.data?.compare)
                    );
                    localStorage.setItem(
                        "wishListItems",
                        JSON.stringify(res.data?.favourites)
                    );
                    this.homePageService.categoriesDataSub.next(
                        res.data?.categories
                    );
                    this.embryoService.compareListSub.next(res.data?.compare);
                    this.embryoService.favouritesListSub.next(
                        res.data?.favourites
                    );
                }
            });
    }
    //================================================================
    hideMultiInv() {
        this.user.show_area_input = false;
        this.auth.setUserDataEmit(this.user);
        if (this.environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup) {
            this.closeFunc.emit(true);
        }
    }
    //================================================================
    resetArea() {
        this.areaForm.controls.area_id.setValue(null);
        this.areaForm.controls.area_id.updateValueAndValidity();
    }
    //================================================================
    onAreaFormSubmit(type: string): void {
        if (this.areaForm.invalid && type != "map") {
            this.areaForm.markAllAsTouched();
            return;
        }
        this.loadingSpinner = true;
        let data = this.areaForm.value;

        if (type == "map") {
            data["lat"] = this.cordnates.lat_marker;
            data["lng"] = this.cordnates.lng_marker;
        }
        this.accountSettingService.UpdateInvintoryArea(data).subscribe(
            (res) => {
                if (res.code == 200) {
                    localStorage.setItem('cityAndArea', JSON.stringify(data));
                    localStorage.setItem('isGuest', 'true');
                    this.router.navigate(["/" + this.lang + "/session/signin"]);
                    this.loadingSpinner = false;
                    this.user = res.data;
                    // this.user["changed"];
                    localStorage.setItem(
                        "auth_user_crocs",
                        JSON.stringify(this.user)
                    );
                    this.auth.setUserDataEmit(this.user);
                    this.auth.setAreaDataEmit(true);
                    localStorage.removeItem("cartItems");
                    this.embryoService.productCartSub.next([]);
                    this.reInitialize();
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${res.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: res.code == 200 ? "#4caf50" : "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }

            },
            (err) => {
                this.loadingSpinner = true;
            }
        );
    }
    //================================================================
    mapReady(map: any) {
        this.mapObj = map;
        map.addListener("dragend", (e: any) => {
            if (this.zoom_level >= 14) {
                this.checkArea(this.cordnates, 16 , 'mapReady');
            }
        });
    }
    //================================================================
    zoomMp(zoomLevel: number) {
        this.zoom_level = zoomLevel;
        if (zoomLevel < 14) {
            this.isPleaseZoom = true;
            if (this.addressForm) {
                this.addressemit.emit({
                    code: 422,
                    message:
                        this.lang == "en"
                            ? "Please zoom in more to find your exact delivery location"
                            : "الرجاء التقريب أكثر لتحديد عنوانك بدقة",
                });
            }

            this.cdRef.detectChanges();
        } else {
            this.isPleaseZoom = false;
            this.cdRef.detectChanges();
            this.checkArea(this.cordnates, 16 , 'zoomMp');
        }
    }
    //================================================================
    public centerChanged(coords: LatLngLiteral) {
        this.cordnates.lat_marker = coords.lat;
        this.cordnates.lng_marker = coords.lng;
    }
    //================================================================
    getAllAreas() {
        this.accountSettingService.getAreas(this.addressForm).subscribe((response: any) => {
            if (response) {
                if (response.code == 200) {
                    let path = response.data.map((x: any) => [
                        ...x.coordinates,
                    ]);
                    this.coordnatesPaths = path;
                }
            }
        });
    }
    //================================================================
    getLocation() {
        if (this.user && this.user.lat && this.user.lng) {
            this.cordnates.lat = this.user.lat;
            this.cordnates.lng = this.user.lng;
            this.cordnates.lat_marker = this.user.lat;
            this.cordnates.lng_marker = this.user.lng;
            this.checkArea(this.cordnates, 16 , 'getLocation');
        }
        if ("geolocation" in navigator) {
            // Geolocation is supported by this device
            navigator.geolocation.getCurrentPosition(
                this.showPosition.bind(this , ''),
                this.userBlockedLocation.bind(this)
            );
        } else {
            // Geolocation is supported by this device
            this.userBlockedLocation();
        }
    }
    //================================================================
    userBlockedLocation() {
        this.getAllAreas();
        if (this.user && this.user.lat && this.user.lng) {
            this.cordnates.lat = this.user.lat;
            this.cordnates.lng = this.user.lng;
            this.cordnates.lat_marker = this.user.lat;
            this.cordnates.lng_marker = this.user.lng;
            this.checkArea(this.cordnates, 16 , 'userBlockedLocation');
        }else{
            this.cordnates.lat = +this.environmentVariables.GOOGLE_MAP_LATITUDE;
            this.cordnates.lng = +this.environmentVariables.GOOGLE_MAP_LONGITUDE;
            this.cordnates.lat_marker =
                +this.environmentVariables.GOOGLE_MAP_LATITUDE;
            this.cordnates.lng_marker =
                +this.environmentVariables.GOOGLE_MAP_LONGITUDE;
            this.checkArea(this.cordnates, 9 , 'config == userBlockedLocation');
        }

    }
    //================================================================
    showPosition(type:string) {
           navigator.geolocation.getCurrentPosition(
              (position) => {
                this.agmMAp.triggerResize().then(() =>
                    this.agmMAp._mapsWrapper.setCenter({
                        lat: this.cordnates.lat,
                        lng: this.cordnates.lng,
                    })
                );
                 if(type == 'location'){
                    this.cordnates.lat = position.coords.latitude;
                    this.cordnates.lng = position.coords.longitude;
                    this.cordnates.lat_marker = position.coords.latitude;
                    this.cordnates.lng_marker = position.coords.longitude;
                    document.getElementById("info-window")!.style.display = "none";
                    this.checkArea(this.cordnates, 16.0001, 'showPosition');
                }
            },
            (userDenied) => {
                if (userDenied.code == 1) {
                    document.getElementById("info-window")!.style.display =
                        "block";
                }
            }
          );
        
   
    }
    //================================================================
    checkArea(cordnates: any, zoom: number , type?:any) {
      // console.log(type);
      
        this.loadingSpinnerDrag = true;
        this.accountSettingService
            .Checkarea(cordnates , this.addressForm)
            .subscribe((response) => {
                if (response) {
                    this.zoom = zoom;
                    this.loadingSpinnerDrag = false;
                    this.mapLoading = false;
                    if (response.code == 200) {
                        this.areaData = response;
                        this.areaData["cordnates"] = cordnates;
                        this.areaDataMessage = "";
                        this.isPleaseZoom = false;
                    } else if (response.code == 422) {
                        this.areaData = response;
                        this.areaDataMessage = response.message;
                    }
                    if (this.addressForm) {
                        this.addressemit.emit(this.areaData);
                    }

                    this.cdRef.detectChanges();
                } else {
                    this.mapLoading = false;
                }
            });
    }
    //================================================================
    clickedMarker() {
        document.getElementById("info-window")!.style.display = "none";
    }
    //================================================================
    backToBoth() {
        this.backToBothFunc.emit(true);
    }
}
